const GenerateRoute = (route, dynamic_data) => {
  let routeString = route;
  Object.keys(dynamic_data).forEach((element) => {
    routeString = routeString.replace(element, dynamic_data[element]);
  });
  return routeString;
};

const GetFormValues = (source, target) => {
  if (typeof source !== 'undefined') {
    for (const key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key) && Object.prototype.hasOwnProperty.call(target, key)) {
        target[key] = source[key];
      }
    }
    return target;
  }
  return undefined;
};

const getDefaultDayNightPackage = (destination) => {
    if (!destination.dayNight || destination.dayNight.length === 0) return null;

    const defaultPackage = destination.dayNight.find(dn => dn.isDefault) || destination.dayNight[0];
    const defaultRating = defaultPackage.ratingDetails.find(r => r.isDefault) || defaultPackage.ratingDetails[0];

    const defaultSlot = Array.isArray(defaultRating?.dateSlots) && defaultRating.dateSlots.length > 0
      ? (defaultRating.dateSlots.find(ds => ds.isDefault) || defaultRating.dateSlots[0])
      : null;

    const computedPrice = defaultSlot
      ? (Number(defaultSlot.finalPrice) > 0 ? Number(defaultSlot.finalPrice) : Number(defaultSlot.price) || 0)
      : (Number(defaultRating?.finalPrice) > 0 ? Number(defaultRating.finalPrice) : Number(defaultRating?.price) || 0);

    return {
      duration: defaultPackage.name,
      price: computedPrice,
      originalPrice: defaultSlot ? (Number(defaultSlot?.price) || computedPrice) : (Number(defaultRating?.price) || computedPrice),
      destinationPoints: defaultPackage.destinationPoints,
      includePackagePoint: defaultPackage.includePackagePoint,
      excludePackagePoint: defaultPackage.excludePackagePoint
    };
  };

  const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const dateObj = new Date(dateStr);
  return dateObj.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

export { GenerateRoute, GetFormValues, getDefaultDayNightPackage, formatDate };
